class FostrCartInfo extends HTMLElement {
  connectedCallback() {
    this.setEventListeners()
  }

  setEventListeners() {
    this.openTrigger.addEventListener('click', this.openModal.bind(this))
    this.closeTrigger.addEventListener('click', this.closeModal.bind(this))
    this.backdrop.addEventListener('click', this.closeModal.bind(this))
  }

  openModal() {
    this.modal.show()
  }

  closeModal() {
    this.modal.close()
  }

  get modal() {
    return this.querySelector('[data-cart-info-dialog-el="modal"]')
  }

  get openTrigger() {
    return document.querySelector('[data-cart-info-dialog-external-el="trigger"]')
  }

  get closeTrigger() {
    return this.querySelector('[data-cart-info-dialog-el="close"]')
  }

  get backdrop() {
    return this.querySelector('[data-cart-info-dialog-el="backdrop"]')
  }
}

customElements.define('fostr-cart-info', FostrCartInfo)
